import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'xemex-info-banner',
  standalone: true,
  imports: [MatIconModule],
  styleUrl: './info-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="info-banner">
      <mat-icon class="info-banner__icon">info</mat-icon>
      <div class="info-banner__message"><ng-content /></div>
    </div>
  `,
})
export class InfoBannerComponent {}
